import React, {useEffect, useState} from "react";
import initialSections from "./initialSections";
import animateTo from "./util/animateTo";
import addSection from "./addSection";


const useSectionControl = (
    {
        status,
        setStatus,
        selectedSectionId,
        setSelectedSectionId,
        product,
        sections,

    }) => {
    const [selectedSectionId2, setSelectedSectionId2] = useState(null);
    const [initialized, setInitialized] = useState(false);
    
    // Handle initial setup once
    useEffect(() => {

        if (status.initialized && initialized === false) {
            if(sections.length === 0) return;
            initialSections({ sections, product, setSelectedSectionId }).then((statusUpdate) => {
                setStatus({
                    ...status,
                    ...statusUpdate
                });
                setInitialized(true);
            });
        }
    }, [status.initialized]);
    
    useEffect(() => {

        if(!status.initialized) return;

        // If all sections are not loaded in the 3D viewer, add the new sections
        let threeSectionsList = window.threeViewer.scene.children.filter(child => child.type === "section");
        let newSections = []
        sections.forEach(element => {
            let section = threeSectionsList.find(s => s.userData.id === element.sectionId);
            if(!section) {
                newSections.push(element)
            }
        });
        if(newSections.length === 0) return;
        newSections.forEach((section) => {
            addSection({
                sectionData: section,
                product,
                setSelectedSectionId
            })
        })
    },[sections])
    
    // Handle section selection updates
    useEffect(() => {
        if(!selectedSectionId && sections.length === 0){
            let threeViewer = window.threeViewer;
            let product = threeViewer?.product;
            let controls = threeViewer?.controls;
            if(!product) return;
            controls.fitToBox(product, true)
        }

        if (selectedSectionId !== selectedSectionId2) {
            setSelectedSectionId(selectedSectionId); // Update state to reflect the new selected section
            //if(!snap.ui.zoom) {
            animateTo(selectedSectionId, {
                fit: false,//!!snap.ui.zoom//!!selectedSectionId
                current: false,
                options : {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            })
            //}
        }
        
        
    }, [selectedSectionId]);
}

export default useSectionControl;